module.exports = __webpack_public_path__ + "static/media/programmer.5faf790b.svg";